export default __webpack_public_path__ + "static/media/e6e9bb14878b33c6.7a2d7a033c6edcb2aa1900eadb08967d.svg";